import Reveal from '@/components/base/Reveal';
import SectionLabel from '@/components/base/SectionLabel';
import { brandIntroImage } from '../data';

export default function BrandIntro() {
  return (
    <section className="bg-background-50 py-20 md:py-28">
      <div className="mx-auto grid max-w-7xl grid-cols-1 lg:grid-cols-2 items-center gap-12 lg:gap-20 px-4 md:px-6">
        {/* Image */}
        <Reveal className="relative">
          <div className="img-zoom rounded-lg overflow-hidden">
            <img
              src={brandIntroImage}
              alt="Folded traditional Indian silk sarees in burgundy, gold and emerald"
              className="h-[420px] md:h-[520px] w-full object-cover object-top"
            />
          </div>
          <div className="absolute -bottom-5 -right-4 md:right-8 rounded-md bg-primary-500 px-6 py-4 text-background-50">
            <p className="font-heading text-3xl md:text-4xl font-medium">100%</p>
            <p className="text-[11px] uppercase tracking-[0.2em] text-background-100/80">Indian Heritage</p>
          </div>
        </Reveal>

        {/* Text */}
        <Reveal delay={120}>
          <SectionLabel>Our Philosophy</SectionLabel>
          <h2 className="mt-4 font-heading text-4xl md:text-5xl leading-[1.12] font-medium text-foreground-950">
            More Than Fabric.
            <br />
            It&rsquo;s Heritage.
          </h2>
          <p className="mt-6 max-w-lg text-[15px] md:text-base leading-relaxed text-foreground-700">
            Indian clothing carries stories of family, celebration, identity and tradition.
            SRM Textiles brings these timeless styles into a modern UK experience — honouring
            the craftsmanship and cultural meaning behind every saree, dhoti and traditional
            garment.
          </p>
          <p className="mt-4 max-w-lg text-[15px] md:text-base leading-relaxed text-foreground-600">
            Whether you are searching for a wedding saree, a veshti for a family celebration
            or traditional clothing for a special occasion, we help you find pieces that feel
            authentic and made for you.
          </p>
          <a
            href="#story"
            className="mt-8 inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-primary-300 px-6 py-3 text-sm font-semibold text-primary-600 transition-colors hover:bg-primary-50"
          >
            Discover Our Story
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </a>
        </Reveal>
      </div>
    </section>
  );
}